export default __webpack_public_path__ + "static/media/porsche.49e1448a.svg";